/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonApiLogInfo
 */
export interface JsonApiLogInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonApiLogInfo
     */
    allowedActions?: Array<JsonApiLogInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonApiLogInfo
     */
    ammoLogId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    ammoStatus?: JsonApiLogInfoAmmoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    apiResult?: JsonApiLogInfoApiResultEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    apiType?: JsonApiLogInfoApiTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    barcode?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    cateringMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    cateringStatus?: JsonApiLogInfoCateringStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    cateringType?: JsonApiLogInfoCateringTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonApiLogInfo
     */
    dayNo?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    errorMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonApiLogInfo
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonApiLogInfo
     */
    logId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonApiLogInfo
     */
    placeId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonApiLogInfo
     */
    readerId?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoAmmoStatusEnum {
    Used = 'USED',
    Ignored = 'IGNORED'
}/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoApiResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoApiTypeEnum {
    Check = 'check',
    Vip = 'vip',
    Catering = 'catering',
    Ammo = 'ammo'
}/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoCateringStatusEnum {
    OkAvailable = 'OK_AVAILABLE',
    OkUsingNow = 'OK_USING_NOW',
    ErrorAlreadyUsed = 'ERROR_ALREADY_USED',
    ErrorGroupUsed = 'ERROR_GROUP_USED',
    ErrorNoCatering = 'ERROR_NO_CATERING',
    ErrorWrongPlace = 'ERROR_WRONG_PLACE'
}/**
* @export
* @enum {string}
*/
export enum JsonApiLogInfoCateringTypeEnum {
    Br = 'BR',
    Lu = 'LU',
    Di = 'DI',
    Sn = 'SN'
}

export function JsonApiLogInfoFromJSON(json: any): JsonApiLogInfo {
    return JsonApiLogInfoFromJSONTyped(json, false);
}

export function JsonApiLogInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonApiLogInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'ammoLogId': !exists(json, 'ammoLogId') ? undefined : json['ammoLogId'],
        'ammoStatus': !exists(json, 'ammoStatus') ? undefined : json['ammoStatus'],
        'apiResult': !exists(json, 'apiResult') ? undefined : json['apiResult'],
        'apiType': !exists(json, 'apiType') ? undefined : json['apiType'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
        'cateringMessage': !exists(json, 'cateringMessage') ? undefined : json['cateringMessage'],
        'cateringStatus': !exists(json, 'cateringStatus') ? undefined : json['cateringStatus'],
        'cateringType': !exists(json, 'cateringType') ? undefined : json['cateringType'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'dayNo': !exists(json, 'dayNo') ? undefined : json['dayNo'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'logId': !exists(json, 'logId') ? undefined : json['logId'],
        'placeId': !exists(json, 'placeId') ? undefined : json['placeId'],
        'readerId': !exists(json, 'readerId') ? undefined : json['readerId'],
    };
}

export function JsonApiLogInfoToJSON(value?: JsonApiLogInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'ammoLogId': value.ammoLogId,
        'ammoStatus': value.ammoStatus,
        'apiResult': value.apiResult,
        'apiType': value.apiType,
        'barcode': value.barcode,
        'cateringMessage': value.cateringMessage,
        'cateringStatus': value.cateringStatus,
        'cateringType': value.cateringType,
        'createdAt': value.createdAt,
        'dayNo': value.dayNo,
        'errorMessage': value.errorMessage,
        'eventId': value.eventId,
        'logId': value.logId,
        'placeId': value.placeId,
        'readerId': value.readerId,
    };
}

